import { render } from "./UserInfo.vue?vue&type=template&id=b76df68c&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=b76df68c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b76df68c"

export default script